export default {
  myFiles: 'Moji dokumenti',
  newDocument: 'Novi dokument',
  messages: 'Poruke',
  addresses: 'Adrese',
  newAddress: '+ Nova adresa',
  aboutUs: 'O nama',
  addArticle: 'Dodaj artikal',
  addAttribute: 'Dodaj atribut',
  addBank: 'Dodaj banku',
  addBlog: 'Dodaj novost',
  addBrand: 'Dodaj brand',
  addCategory: 'Dodaj kategoriju',
  addCompany: 'Dodaj kompaniju',
  addCountry: 'Dodaj državu',
  addCurrency: 'Dodaj valutu',
  addCustomerBankAccount: 'Dodaj korisnički račun',
  accountDetails: 'Detalji o profilu',
  addExpressPost: 'Dodaj brzu poštu',
  addInterestsArea: 'Dodaj djelatnost',
  addMeasurementUnit: 'Dodaj jedinicu mjere',
  addPoll: 'Dodaj anketu',
  addProductSale: 'Dodaj akciju',
  addTab: 'Dodaj tab',
  blog: 'Blog',
  addTown: 'Dodaj grad',
  addToCart: 'Dodaj u korpu',
  addToCart2: 'U košaricu',
  docDate: 'Datum dok',
  account: 'Konto',
  owes: 'Duguje',
  comment: 'Komentar',
  accountNumber: 'Broj računa',
  claims: 'Potražuje',
  paymentTerm: 'Rok plaćanja',
  bookingDateShort: 'Datum knj',
  addUser: 'Dodaj korisnika',
  addVariation: 'Dodaj varijaciju',
  apply: 'Primjeni',
  article: 'Proizvod',
  areYouSureArticle: 'Jeste li sigurni da želite izbrisati artikal {article}?',
  areYouSureAttribute: 'Jeste li sigurni da želite izbrisati atribut {attribute}?',
  areYouSureAttributeArticle: 'Jeste li sigurni da želite izbrisati atribut?',
  areYouSureAttributeValue:
    'Jeste li sigurni da želite izbrisati {attributeValue} vrijednost atributa?',
  areYouSureBank: 'Jeste li sigurni da želite izbrisati banku {bank}?',
  areYouSureBlog: 'Jeste li sigurni da želite izbrisati novost {blog}?',
  areYouSureBrand: 'Jeste li sigurni da želite izbrisati brend {brand}?',
  areYouSureCategory: 'Jeste li sigurni da želite izbrisati kategoriju {category}?',
  areYouSureCompany: 'Jeste li sigurni da želite izbrisati kompaniju {company}?',
  areYouSureCountry: 'Jeste li sigurni da želite izbrisati državu {country}?',
  areYouSureCurrency: 'Jeste li sigurni da želite izbrisati valutu {currency}?',
  areYouSureCustomerBankAccount:
    'Jeste li sigurni da želite izbrisati korisnički bankovni račun {bankAccount}?',
  areYouSureExpressPost: 'Jeste li sigurni da želite izbrisati brzu poštu {post}?',
  areYouSureInterestsArea: 'Jeste li sigurni da želite izbrisati djelatnost {area}?',
  areYouSureProductSale: 'Jeste li sigurni da želite izbrisati akciju {productSale}?',
  areYouSureSelected: 'Jeste li sigurni da želite izbrisati odabrane zapise?',
  areYouSureTab: 'Jeste li sigurni da želite izbrisati tab {tab}?',
  areYouSureTown: 'Jeste li sigurni da želite izbrisati grad {town}?',
  areYouSureUser: 'Jeste li sigurni da želite izbrisati korisnika {user}?',
  areYouSureCancelOrder: 'Da li ste sigurni da želite otkazati narudžbu?',
  areYouSureApproveOrder: 'Da li ste sigurni da želite odobriti narudžbu?',
  areYouSureDeleteShoppingCart: 'Da li ste sigurni da želite izbrisati korpu?',
  shoppingCartNotConcluded: 'Trenutno imate nezaključenu korpu.',
  shoppingCartItemsReplacement: 'Stavke u korpi će biti zamjenjene stavkama iz sačuvane korpe.',
  doYouWantToContinue: 'Želite li nastaviti?',
  thereAreCurrentlyNoSavedShoppingCarts: 'Nemate spremljenih korpi.',
  articleDetails: 'Detalji artikla',
  articleDetailsInfo: 'Unesite detalje artikla',
  articles: 'Artikli',
  attributes: 'Atributi',
  banks: 'Banke',
  blogs: 'Novosti',
  brands: 'Brendovi',
  brand: 'Brend',
  service: 'Servis',
  cancel: 'Otkaži',
  newRequest: 'Novi zahtjev',
  contactPerson: 'Kontakt osoba',
  categories: 'Kategorije',
  category: 'Kategorija',
  serialNumber: 'Serijski broj',
  productCode: 'Šifra proizvoda',
  checkout: 'Naplata',
  download: 'Preuzmi',
  actions: 'Akcije',
  sales: 'Akcije',
  folderIsEmpty: 'Vaša mapa sa dokumentima je prazna',
  physicalPersons: 'Fizička lica',
  goToCheckout: 'Idi na naplatu',
  choose: 'Izaberite',
  chooseOptions: 'Izaberite opcije',
  contact: 'Kontakt',
  onlineShopping: 'Online kupovina',
  ord: 'Rbr',
  myAccount2: 'Moj nalog',
  myArticles: 'Moji proizvodi',
  followUsOnSocialMedia: 'Pratite nas na društvenim mrežama',
  deliveryAndPayment: 'Dostava i plaćanje',
  complaintsAndReturns: 'Reklamacija i povrati',
  securityAndPrivacy: 'Sigurnost i privatnost',
  termsOfService: 'Uvjeti korištenja i kupovine',
  youNeedHelp: 'Trebate pomoć?',
  from: 'Od',
  to: 'Do',
  title: 'Naslov',
  markAllAsRead: 'Označi sve kao pročitano',
  faq: 'Česta pitanja',
  howToRegister: 'Kako se registrirati?',
  shoppingHelp: 'Pomoć pri kupovini',
  bonusProgramRules: 'Pravila Bonus programa',
  comingSoon: 'Uskoro',
  companies: 'Kompanije',
  countries: 'Države',
  countryDetails: 'Detalji države',
  countryDetailsInfo: 'Unesite detalje države',
  viewFinances: 'Pogledaj financije',
  coupons: 'Kuponi',
  currencies: 'Valute',
  customerBankAccounts: 'Korisnički računi',
  profileDashboard: 'Dashboard',
  defaultAddress: 'Sljedeće adrese će se prema zadanim postavkama koristiti na stranici za naplatu.',
  delete: 'Izbriši',
  currentDebt: 'Trenutno zaduženje',
  deleteArticle: 'Izbriši artikal',
  paymentTerms: 'Uvjeti plaćanja',
  deleteAttribute: 'Izbriši atribut',
  debtOutsideCurrency: 'Dug van valute',
  deleteBank: 'Izbriši banku',
  deleteBlog: 'Izbriši novost',
  edit: 'Izmjeni',
  approvedDebt: 'Odobreno zaduženje',
  deleteBrand: 'Izbriši brand',
  deleteCategory: 'Izbriši kategoriju',
  notSetAnyAddressYet: 'Još niste postavili nijednu adresu.',
  deleteCompany: 'Izbriši kompaniju',
  deleteCountry: 'Izbriši državu',
  deleteCurrency: 'Izbriši valutu',
  deleteCustomerBankAccount: 'Izbriši korisnički bankovni račun',
  deleteExpressPost: 'Izbriši brzu poštu',
  deleteInterestsArea: 'Izbriši djelatnost',
  deleteProductSale: 'Izbriši akciju',
  deleteSelected: 'Izbriši odabrano',
  deleteTab: 'Izbriši tab',
  deleteTown: 'Izbriši grad',
  deleteUser: 'Izbriši korisnika',
  deleteVariationImage: 'Jeste li sigurni da želite izbrisati sliku varijacije?',
  details: 'Detalji',
  detailsInfo: 'Unesite detalje',
  editArticle: 'Ažuriraj artikal',
  editAttribute: 'Ažuriraj atribut',
  editBank: 'Ažuriraj banku',
  editBlog: 'Ažuriraj novost',
  editBrand: 'Ažuriraj brand',
  editCategory: 'Ažuriraj kategoriju',
  editCompany: 'Ažuriraj kompaniju',
  editCountry: 'Ažuriraj državu',
  editCurrency: 'Ažuriraj valutu',
  editCustomerBankAccount: 'Ažuriraj korisnički račun',
  editExpressPost: 'Ažuriraj brzu poštu',
  editInterestArea: 'Ažuriraj djelatnost',
  editPoll: 'Ažuriraj anketu',
  editProductSale: 'Ažuriraj akciju',
  editTab: 'Ažuriraj tab',
  editTown: 'Ažuriraj grad',
  editUser: 'Ažuriraj korisnika',
  expressPosts: 'Brze pošte',
  forgotPassword: 'Zaboravljena lozinka',
  greetings: 'Zdravo',
  homePageTitle: 'Početna',
  highlightedCategories: 'Izdvojeno',
  import: 'Importuj',
  importArticles: 'Importuj artikle',
  interestsAreas: 'Djelatnosti',
  cancel2: 'ODUSTANI',
  cancel3: 'Odustani',
  login: 'Prijava',
  logIn: 'Prijavi se',
  logout: 'Odjava',
  measurementUnits: 'Jedinice mjere',
  myAccount: 'Moj profil',
  delete2: 'IZBRIŠI',
  myProfile: 'Profil',
  news: 'Vijesti',
  newArticles: 'Novi proizvodi',
  no: 'Ne',
  attention: 'Pažnja',
  warning: 'Upozorenje',
  areYouSureYouWantToDeleteAcc: 'Da li sigurno želite izbrisati vaš račun? Unesite lozinku da bi ste izbrisali vaš račun.',
  areYouSureYouWantToDeleteAddress: 'Jeste li sigurni da želite ukloniti odabranu adresu?',
  noItemSelected: 'Nema odabranih zapisa',
  noRecords: 'Nema rezultata prema traženim parametrima',
  notFound: 'Trazena stranica nije pronadjena',
  orderArticles: 'Artikli u košarici',
  orders: 'Narudžbe',
  polls: 'Ankete',
  priceRange: 'Cijenovni rang',
  productSales: 'Akcije',
  recentlyViewdItems: 'Ranije ste gledali',
  register: 'Registracija',
  resetFilters: 'Poništi filtere',
  rma: 'Prijavljene nepravilnosti (RMA)',
  uploadAttachment: 'Priložite slike, datoteke...',
  rmaForm: 'Reklamacije',
  save: 'Sačuvaj',
  saveShoppingCart: 'Spremi korpu',
  saveArticle: 'Sačuvaj artikal',
  saveCategory: 'Sačuvaj kategoriju',
  saveCountry: 'Sačuvaj državu',
  search: 'Pretraga',
  find: 'Unesite minimalno 3 karaktera...',
  selectAction: 'Izaberite akciju',
  shoppingCart: 'Korpa',
  tabs: 'Tabovi',
  terms: 'Uslovi korištenja',
  townDetails: 'Detalji grada',
  townDetailsInfo: 'Unesite detalje grada',
  towns: 'Gradovi',
  total: 'Ukupno',
  amount: 'Iznos',
  topBrands: 'Top Brendovi',
  userProfile: 'Korisnički profil',
  users: 'Korisnici',
  userArticles: 'Proizvodi odabrani za vas',
  viewAll: 'Vidi sve',
  viewAllFrom: 'Vidi sve iz',
  addToCartSuccessMessage: 'Upravo ste dodali artikl u <br/> košaricu: ',
  continueShopping: 'Nastavi kupnju',
  clearShoppingCart: 'Isprazni košaricu',
  updateShoppingCart: 'Ažuriraj košaricu',
  goToShoppingCart: 'Idi u košaricu',
  areYourSureEmptyShoppingCart: 'Da li ste sigurni da želite isprazniti košaricu?',
  wishlist: 'Lista želja',
  addToWishlist: 'Dodaj u listu želja',
  yes: 'Da',
  reviews: 'Recenzija',
  tabReviews: 'Recenzije',
  writeReview: 'Unesite Vašu recenziju',
  submitReview: 'Pošalji recenziju',
  anonymous: 'Anonimno',
  linkedArticles: 'Povezani proizvodi',
  quickPreview: 'Brzi pregled',
  loginRegisterTitle: 'Prijava / Kreiranje računa',
  loginTitle: 'Prijava',
  loginSubTitle: 'Ukoliko imate korisnički račun prijavite se.',
  loginButton: 'PRIJAVA',
  registerTitle: 'Zatražite korisnički račun',
  registerSubTitle: 'Popunite tražene informacije i naš tim će vas kontaktirati u najkraćem roku,te ćemo vam izraditi korisnički račun. Hvala!',
  chooseCountry: 'Izaberite državu',
  chooseTown: 'Izaberite grad',
  registerSectionLoginDataTitle: 'Podaci za prijavu',
  acceptTerms: 'Prihvatam uvjete korištenja',
  registerSubmit: 'Zatraži račun',
  repeatOrder: 'Ponovi narudžbu',
  close: 'Zatvori',
  defaultSort: 'Zadano sortiranje',
  sortByRating: 'Sortiraj po ocjeni',
  sortByDateOldest: 'Sortiraj po datumu objave: starije prema novom',
  sortByDateNewest: 'Sortiraj po datumu objave: novo prema starijem',
  sortByPriceLow: 'Sortiraj po cijeni: niža prema višoj',
  sortByPriceHigh: 'Sortiraj po cijeni: viša prema nižoj',
  pagingResults: 'Prikazuje se {fromResults} - {toResults} od {totalItems} rezultata',
  showMore: 'Prikaži više',
  productIsAvalible: 'Proizvod je dostupan',
  productIsAvalibleToOrder: 'Proizvod je dostupan po narudžbi',
  deliveryTimeDays: 'Vrijeme isporuke je {days} dana od narudžbe proizvoda',
  itemIsAvalibleContactRepresentative: 'Artikal je dostupan po narudžbi. Molimo kontaktirajte Vašeg prodajnog predstavnika.',
  availableOnRequest: 'Dostupno na upit',
  requestPresentation: 'Zatraži prezentaciju',
  howDoYouRateThisProduct: 'Kako ocjenjujete ovaj proizvod?',
  administrator: 'Administrator',
  passwordRecovery: 'Oporavak lozinke',
  enterYourEmailAddressBelowAndWellSendYouInstructions: 'Unesite Vašu e-mail adresu ispod i poslat ćemo vam upute za resetovanje!',
  reset: 'Resetuj',
  remembered: 'Zapamćeno',
  finances: 'Financije',
  allRightsReserved: 'Sva prava pridržana',
  updateAddress: 'Ažuriraj adresu',
  state: 'Država',
  chooseState: 'Izaberite državu',
  listIsEmpty: 'Lista je prazna',
  noResultsAccordingToTheGivenParameters: 'Nema rezultata prema zadanim parametrima',
  termsOfUseIsMandatory: 'Polje Uvjeti korištenja je obavezno',
  resetPassword: 'Reset lozinke',
  accVerificationInProgress: 'Verifikacija računa u toku',
  accVerification: 'Verifikacija računa',
  verificationLinkHasExpired: 'Verifikacijski link je istekao. Molimo kontaktirajte naše administratore: support@eurosan.ba ili +387 36 342 220.',
  youHaveJustAddedAnItemToTheCart: 'Upravo ste dodali artikl u košaricu:',
  manufacturer: 'Proizvođač',
  productName: 'Naziv proizvoda',
  shoppingCarts: 'Košarice',
  preview: 'Pregled',
  documentName: 'Naziv dokumenta',
  status: 'Status',
  orderNumber: 'Broj narudžbe',
  orderer: 'Naručioc',
  date: 'Datum',
  document: 'Dokument',
  delivery: 'Dostava',
  deliverTo: 'Dostaviti na',
  discount: 'Rabat',
  savingsByUsingPromoCode: 'Ušteda korištenjem promo koda',
  itemAddedToCart: 'Artikal dodan u košaricu.',
  articlesOnSale: 'Artikli na akciji',
  controlPanel: 'Kontrolna ploča',
  tags: 'Tagovi',
  totalAmountWithDelivery: 'Ukupno sa dostavom',
  youHaveNotPlacedAnorderYet: 'Niste još uvijek napravili narudžbu',
  quantity: 'Količina',
  amountWithoutVat: 'Iznos bez PDV-a',
  vatAmount: 'Iznos PDV-a',
  orderNo: 'Narudžba br',
  days: 'dana',
  time: 'Vrijeme',
  quantity2: 'KOLIČINA',
  rejectOrd: 'Odbij nar',
  approveOrd: 'Odobri nar',
  wishListIsEmpty: 'Lista želja prazna',
  sale: 'AKCIJA',
  totalWithoutTax: 'Ukupno bez poreza',
  sendRequest: 'POŠALJI ZAHTJEV',
  promoCode: 'Promo kod',
  send: 'Pošalji',
  registrationCode: 'Šifra prijave',
  created: 'Kreirano',
  giftCard: 'Poklon kod',
  changePassword: 'Promjena lozinke',
  emailAddress: 'Email adresa',
  oldPassword: 'Stara lozinka',
  deleteUserAcc: 'IZBRIŠI KORISNIČKI RAČUN',
  permanentlyDeletedAcc: 'Korisnički račun će biti trajno obrisan',
  confirmNewPassword: 'Potvrdite novu lozinku',
  passwordConfirmation: 'Potvrda lozinke',
  newPassword: 'Nova lozinka',
  newPassLeaveBlank: 'Nova lozinka (ostavite prazno ukoliko ne želite mijenjati)',
  currentPassLeaveBlank: 'Trenutna lozinka (ostavite prazno ukoliko ne želite mijenjati)',
  areasOfInterest: 'Interesna područja',
  chooseAreaOfInterest: 'Izaberite interesna područja',
  totalTax: 'Ukupno poreza',
  price: 'Cijena',
  price2: 'CIJENA',
  newAddress2: 'Nova adresa',
  show: 'Prikaži',
  stock: 'Stanje',
  yourTotalDebtIs: 'Vaše ukupno zaduženje iznosi',
  isInStock: 'Ima na stanju',
  print: 'Print',
  signUpForTheNewsletter: 'Prijavite se na newsletter',
  latestInformations: 'Dobijte sve najnovije informacije o događajima, rasprodajama i ponudama.',
  subscribe: 'Pretplatite se',
  aboutEurosanGroup: 'O Eurosan grupaciji',
  responsibleBusiness: 'Odgovorno poslovanje',
  noDataToAccordingData: 'Nema podataka prema traženim parametrima',
  jobAtEurosan: 'Posao u Eurosanu',
  vpc: 'VPC',
  products: 'proizvoda',
  phoneNumber: 'Broj telefona',
  tax: 'PDV',
  tax2: 'Porez',
  defaultAddress2: 'Zadana adresa',
  totalWithVat: 'Ukupno sa PDV',
  totalWithoutVat2: 'Ukupno bez PDV',
  summary: 'Sažetak',
  warranty: 'Garancija',
  zipCode: 'Zip kôd',
  indeterminate: 'Neodređeno',
  description: 'Opis',
  completeSolutionsForYourBusiness: 'Kompletna rješenja za uspjeh Vašeg poslovanja',
  whoAreWe: 'KO SMO MI',
  about: {
    aboutEurosan: 'Eurosan Ecotime grupacija nastala je 1998. godine inspirirana željom za zdravijim i sretnijim radnim prostorima. Naš cilj je jasan: biti Vaš pouzdan partner u održavanju čistoće, higijene i sigurnosti. Vjerujemo da čisto i sigurno radno okruženje pokreće uspjeh.',
    aboutEurosan2: '"Zdravije, sigurnije, produktivnije" - to je naše obećanje Vama!',
    aboutEurosan3: 'Kroz naše sveobuhvatne usluge i proizvode - od profesionalnog čišćenja do ekološki prihvatljivih proizvoda i zaštitne opreme - mi stvaramo prostore u kojima ljudi dišu lakše, rade učinkovitije i žive zdravije.',
    aboutEurosan4: 'Odaberite nas i pridružite nam se u stvaranju zdravije i sigurnije budućnosti.',
    ourMission: 'NAŠA MISIJA',
    mission: 'Biti vaš pouzdani partner u stvaranju čistog, sigurnog i održivog okruženja kroz prilagođena rješenja i iznimnu uslugu.',
    ourVision: 'NAŠA VIZIJA',
    vision: 'Postati lider u pružanju održivih i prilagođenih rješenja za čišću, zdraviju i sigurniju budućnost, uvijek stavljajući potrebe naših klijenata na prvo mjesto.',
    ourValues: 'NAŠE VRIJEDNOSTI',
    values: 'Naše temeljne vrijednosti označavaju ono što jesmo, što radimo i način na koji to radimo, a one su visok kvalitet usluga i proizvoda, znanje o higijeni i briga o sigurnosti i zdravlju ljudi.',
    whyChooseUs: 'ZAŠTO NAS ODABRATI?',
    efficiency: 'UČINKOVITOST:',
    efficiencyText: 'Čistite pametnije, radite manje.',
    improvedHygiene: 'POBOLJŠANA HIGIJENA:',
    improvedHygieneText: ' Izvanredna razina higijene za svaki prostor.',
    effectiveCleaning: 'DJELOTVORNO ČIŠĆENJE:',
    effectiveCleaningText: ' Snaga čistoće u svakoj ambalaži.',
    improvedWorkerSafety: 'POBOLJŠANA SIGURNOST RADNIKA:',
    improvedWorkerSafetyText: ' Zaštitite svoje radnike vrhunskom zaštitnom opremom.',
    improvedDineExperience: 'POBOLJŠANO GASTRONOMSKO ISKUSTVO:',
    improvedDineExperienceText: ' Atmosfera koja odiše luksuzom i kvalitetom.',
    greaterGuestSatisfaction: 'VEĆE ZADOVOLJSTVO GOSTIJU:',
    greaterGuestSatisfactionText: ' Ekološki prihvatljiva hotelska kozmetika vrhunske kvalitete.',
    timeSaving: 'UŠTEDA VREMENA:',
    timeSavingText: ' Uštedite vrijeme i energiju - prepustite brigu o čišćenju nama.',
    longerEquipmentLife: 'DUŽI VIJEK TRAJANJA OPREME:',
    longerEquipmentLifeText: ' Za bezbrižnost - Vaša oprema u sigurnim rukama našeg servisa.',
    atService: 'Ponosno smo na usluzi više od ',
    threeThousandClients: '3.000 klijenata',
    inCountries: 'u BiH, Srbiji i Crnoj Gori',
    yearsOfExistence: 'Godina postojanja',
    numberOfEmployees: 'Djelatnika',
    activeArticles: 'Aktivnih artikala',
  },
  recentBlogs: 'Nedavne vijesti',
  readMore: 'Pročitaj više',
  searchFor: 'Pretraga',
  archive: 'Arhiva',
  payment: 'Plaćanje',
  deliveryAddress: 'Adresa za dostavu',
  deliverHere: 'Dostaviti ovdje',
  deliveryAddressValidationMessage: 'Molimo Vas da unesete bar jednu adresu za dostavu prije nego što nastavite sa procesuiranjem narudžbe',
  deliveryMethod: 'Način dostave',
  free: 'Besplatno',
  deliveryTime: 'Vrijeme isporuke 2 do 3 radna dana',
  personalPickup: 'Osobno preuzimanje',
  personalVisitToTheBranch: 'Osobni odlazak u poslovnicu',
  ourDelivery: 'Naša dostava',
  deliverySevenDays: 'Vrijeme isporuke cca. 7 dana',
  orderAmountFromText: '*Iznosom narudžbe od ',
  getFreeDeliveryText: ' KM ostvarujete besplatnu dostavu',
  articlesInShoppingCart: ' artikala u košarici',
  orderTotalAmountWithoutVat: 'Ukupno narudžba (bez PDV): ',
  orderTotalBruttoWeight: 'Ukupna kilaža ',
  promoCodeDiscount: '*Ušteda prilikom korištenja promo koda: ',
  postage: 'Poštarina',
  totalOrderAmountWithPostage: 'Ukupno s poštarinom: ',
  paymentMethod: 'Način plaćanja',
  note: 'Napomena',
  acceptTermsOfUse: 'Prihvatam uvjete korištenja',
  back: 'Natrag',
  placeOrder: 'Zaključi narudžbu',
  nextStep: 'DALJE',
  complaints: {
    complaints: 'Reklamacije',
    privateBuyers: 'Za privatne kupce:',
    text1: 'Ukoliko ustanovite, prilikom prve upotrebe (unutar 7 dana od primitka), da je proizvod koji ste dobili neispravan molimo Vas da nas kontaktirate i slijedite navedene korake:',
    text2: 'Pošaljite nam informacije s brojem narudžbe, brojem računa ili vašim korisničkim imenom i opisom reklamacije putem',
    emailAddress: ' e-mail adrese ',
    phone: 'ili telefonski na ',
    text3: 'Poslat ćemo Vam potvrdu primitka reklamacije i, temeljem Vašeg opisa reklamacije, informaciju o tome može li se proizvod zamijeniti za novi i može li se za proizvod vratiti novac.',
    text4: 'U slučajevima kad se proizvod može zamijeniti za novi i kad se za proizvod može vratiti novac, na Vašu adresu šaljemo dostavnu službu koja prikuplja reklamirani proizvod i vraća na naše skladište. Vaša obaveza je da proizvod zapakujete i spremite za preuzimanje brze pošte u originalnoj ambalaži sa svim dodacima i dokumentacijom koju ste dobili uz proizvod. Kad proizvod stigne na skladište, nakon što bude pregledan, šaljemo Vam obavijest o povratu novaca/slanju zamjenskog proizvoda. Povrat novca/zamjena za novi proizvod bit će odrađena unutar 2-3 dana, a najkasnije nakon 15 dana. U suprotnom nas kontaktirajte telefonski na 080 080 080 ili e-mailom na webshop@eurosan.ba',
    text5: 'Ako je ambalaža oštećena nemojte preuzimati proizvod, nego dostavljaču skrenite pažnju na oštećenje ambalaže i zatražite da proizvod vrati u Eurosan. Ako kupac ne reklamira oštećenje ambalaže dostavljaču u trenutku preuzimanja proizvoda, smatra se da je preuzeo proizvod s neoštećenom ambalažom.',
    text6: 'U slučaju da proizvod koji ste dobili ne odgovara slikom ili specifikacijom proizvodu koji ste naručili isti možete zamijeniti ili vratiti u zamjenu za novac unutar 7 dana od primitka. Za ostvarivanje ovog prava, potrebno je neoštećeni proizvod poslati u originalnom pakiranju sa svom opremom i dokumentacijom s kojim je proizvod bio originalno isporučen.',
    businessCustomers: 'Za poslovne kupce: ',
    text7: 'Poslovni kupci popunjavaju obrazac zvani "Reklamacije" pomoću kojeg šalju reklamacije poduzeću Eurosan d.o.o. Na eurosan.ba web shopu u odjeljku "Moj profil" se nalazi obrazac koji popunjavate na način da upišete kontakt osobu, naziv i šifru proizvoda, brend, serijski broj, upišete opis, priložite sliku, te napišete broj računa. Na kraju kliknete pošalji, a na istom mjestu možete pratiti stanje vaše reklamacije, da li je na čekanju ili završena. Na isti način možete poslati zahtjev ukoliko trebate servisirati mašinu koja ne radi. U tom slučaju je veoma bitno poslati slike kako bi Eurosan serviseri mogli točno znati o čemu se radi.',
    text8: 'Za sve dodatne informacije možete kontaktirati svog prodajnog predstavnika, pozvati nas na',
    text9: '080 080 080 ili poslati e-mail na ',
  },
  contactUs: {
    commercialist: 'Komercijalist',
    eurosan: 'Eurosan d.o.o.',
    workTimeText: 'Radno vrijeme',
    workTime1: 'Ponedjeljak - Petak: 07:30-16:00',
    workTime2: 'Subota (od 6. do 10. mjeseca): 08:00-12:00',
    address1: 'Bišće polje bb, 88000 Mostar',
    ecotime: 'Ecotime d.o.o.',
    workTime3: 'Ponedjeljak - Petak: 08:00-16:00',
    workTime4: 'Subota: 08:00-12:00',
    address2: 'Lužansko polje 7, 71210 Ilidža',
    eurosanBl: 'Eurosan Banja Luka d.o.o.',
    workTime5: 'Subota: 09:00-13:00',
    address3: 'Jovana Bijelića bb, 78000 Banja Luka',
  },
  FAQ: {
    faq: 'Česta pitanja / FAQ',
    text1: ' Kako bismo olakšali snalaženje na našem web shopu, odgovorili smo na vaša najčešća pitanja. Vjerujemo da će vam odgovori pomoći kako biste što lakše, brže i bez nedoumica izvršili narudžbu željenog proizvoda.',
    q1: 'Kako se registrirati i napraviti profil?',
    text2: 'Kada otvorite naš web shop trebat ćete zatražiti korisnički račun popunjavanjem traženih informacija. Nakon toga, naš tim će vas kontaktirati u najkraćem roku, te ćemo vam izraditi korisnički račun. Podaci koje trebate popuniti su: ime i prezime, kompanija, telefon, adresa, država, grad i interesna područja. Kada su u pitanju interesna područja, bitno je da označite onaj sektor kojem pripadate i kojim se bavite, bilo da su to zdravstvene ustanove, ugostiteljstvo, teretane, proizvodnja ili drugo ponuđeno.',
    text3: 'Možete kupovati bez pravljenja korisničkog računa, dakle kao gost. Potrebno je samo da unesete svoje podatke za dostavu, kao i email kako bismo vam mogli poslati potvrdu uspješne kupovine. Prijaviti se možete i preko Facebook i Google platformi koje su ponuđene.',
    q2: 'Kako naručiti proizvode?',
    text4: 'Naručivanje je vrlo jednostavno, otvorite artikl koji želite naručiti, kliknete "u košaricu", ili na brzom pregledniku kliknete odgovarajuću ikonicu koja se nalazi u desnom uglu slike. Kada završite sa dodavanjem artikala, otvorite korpu i idite na naplatu. Izaberite adresu za dostavu, način dostave i način plaćanja. Na kraju kliknete "zaključi narudžbu" i samim time vaša narudžba je poslana. Na vašu email adresu stiže potvrda o izvršenoj narudžbi.',
    text5: 'Otvorite artikl koji želite naručiti i dodajte ga u košaricu. Kada završite sa dodavanjem artikala, otvorite korpu i idite na naplatu. Ispunite podatke koji se traže od vas, a to su: ime i prezime, adresa, e-mail adresa, broj telefona i način plaćanja. Na kraju kliknete "zaključi narudžbu" i samim time vaša narudžba je poslana. Na vašu email adresu stiže potvrda o izvršenoj narudžbi.',
    q3: 'Kako se vrši dostava?',
    text6: 'Poslovni kupci imaju više opcija dostave, a to su:',
    eurosanFreeDelivery: 'Eurosan besplatna dostava',
    postDelivery: 'dostava brzom poštom (Hrvatska pošta Mostar)',
    text7: 'lično preuzimanje u gradovima Mostar, Sarajevo i Banja Luka, odnosno u firmama Grupe',
    text8: 'Dostava se vrši brzom poštom. (Hrvatska Pošta Mostar uz vrijeme isporuke od 24h)',
    text9: 'Također, kupci mogu osobno preuzeti narudžbu u jednoj od naših poslovnica u Mostaru, Sarajevu ili Banja Luci.',
    q4: 'Da li su vaši proizvodi pogodni za male biznise?',
    text10: 'Da, naši proizvodi su pogodni za velike kompanije, male biznise i preduzeća, kao i privatne korisnike i domaćinstva.',
    q5: 'Da li nudite prezentacije, trening ili podršku za vaše proizvode?',
    businessCustomers: 'Poslovni kupci:',
    text11: 'Poslovni kupci imaju opciju prezentacije proizvoda za određene proizvode poput mašina za čišćenje, određenog kemijskog programa, pomagala za čišćenje i sl. Za svaki kupljeni proizvod, kupci će imati trening gdje će naši stručnjaci objasniti na koji način koristiti određeni proizvod. Također, na web shopu u sklopu svakog artikla se nalazi tehnička dokumentacija i način korištenja proizvoda. Svaki kupac ima svog prodajnog predstavnika koji mu je tu kao podrška pri korištenju proizvoda.',
    text12: 'Za sve nejasnoće, poslovni kupci uvijek mogu kontaktirati naš besplatni info telefon',
    text13: ' 080 080 080 ili poslati nam e-mail na ',
    privateBuyers: 'Privatni kupci:',
    text14: 'Privatni kupci nam se putem besplatnog info telefona ',
    text15: 'ili putem drugih kanala komunikacije, uvijek mogu obratiti za pomoć, savjet i pravilan izbor proizvoda za njihovu potrebu u privatne svrhe i domaćinstvo. Korisnička podrška je uvijek dostupna.',
    q6: 'Koje kreditne kartice primate?',
    text16: 'Pored plaćanja gotovinom pouteću, privatni kupci imaju opciju plaćanja i VISA, MasterCard i Maestro karticama.',
    q7: 'Da li dostavljate proizvode van BiH?',
    text17: 'Ne. Naše tržište je lokalno i obuhvaća samo teritoriju Bosne i Hercegovine. Međutim, tu su naše dvije partnerske firme, Interesta d.o.o. u Crnoj Gori i Ecotime d.o.o. Beograd u Srbiji. Za dodatne informacije, budite nas slobodni kontaktirati.',
  },
  newsletterConfirm: {
    backToShop: 'Povratak na trgovinu',
    great: 'Odlično!',
    subscribed: 'Pretplatili ste se na Eurosan Newsletter',
  },
  passwordResetSuccess: 'Lozinka uspješno obnovljena',
  backToLogin: 'Povratak na prijavu',
  addSelected: 'Dodaj odabrane',
  service2: {
    text1: 'Eurosan d.o.o. garantira da svi proizvodi do roka predaje kupcu posjeduju kvalitetu i da su isti bez nedostataka kao i da se mogu koristiti u skladu sa deklariranom namjenom, sukladno deklaraciji proizvođača.',
    text2: 'Kupac je u obavezi da prilikom prijema naručenog proizvoda isti pregleda i utvrdi da li ima nedostataka. Ukoliko se nedostaci utvrde isti će biti otklonjeni u garantnom roku.',
    text3: ' Dužina garantnog roka je navedena u garantnom listu, ukoliko proizvod posjeduje isti.',
    text4: ' U slučaju da je proizvod isporučen sa nedostatkom, kupac ima pravo na zamjenu istoga.',
    text5: 'Od reklamacija su izuzeti nedostaci koji su prouzrokovani nestručnim rukovanjem i suprotno uputstvu proizvođača za rukovanje proizvodima.',
    text6: 'Reklamacije proizvoda se priznaju uz predočeni fiskalni račun i ispravno popunjeni garantni list kao dokaz kupovine. U slučaju reklamacije proizvoda informacije o načinu prijave kvara ili slanju ovlaštenom servisu informacije potražite na garantnom listu isporučenom uz proizvod ili nas ',
    text7: ' kontaktirajte na kontakt telefon 080 080 080 ili putem email adrese ',
    text8: 'Za popravku proizvoda isporučenih od strane Eurosan d.o.o. osigurali smo kvalitetnu uslugu kako u garantnom periodu tako i izvan njega. Naše osoblje servisa stoji vam na raspolaganju za savjete u vezi upotrebe proizvoda, kvarovima te mogućnostima popravke istoga.',
  },
  areYouSureEmptyShoppingCart: 'Da li ste sigurni da želite isprazniti košaricu?',
  discountCode: 'Kod za popust',
  remove: 'Ukloni',
  yourCartIsEmpty: 'Vaša korpa je prazna',
  vpPrice: 'VP Cijena',
  howToRegisterText: 'Kako se registrirati - Vodič za korištenje',
  downloadOurApp: 'Preuzmite našu aplikaciju',
  mobileAppViewText: 'Uživajte u brzoj i sigurnoj kupovini uz najbolje popuste i nove proizvode!',
  bih: 'Bosna i Hercegovina',
  jajce: 'Jajce',
  mostar: 'Mostar',
  sarajevo: 'Sarajevo',
  banjaluka: 'Banja Luka',
  sirokiBrijeg: 'Široki Brijeg',
  bihac: 'Bihać',
  kozarskaDubica: 'Kozarska Dubica',
  teslic: 'Teslić',
  derventa: 'Derventa',
  forms: {
    notValid: 'Unešeni podaci nisu validni!',
    labels: {
      username: 'Korisničko ime',
      abbreviation: 'Skraćenica',
      address: 'Adresa',
      email: 'E-mail adresa',
      articleType: 'Vrsta artikla',
      availableValues: 'Dostupne vrijednosti',
      bank: 'Banka',
      bankAccount: 'Bankovni račun',
      brand: 'Brend',
      catalogNumber: 'Kataloški broj',
      category: 'Kategorija',
      code: 'Šifra',
      company: 'Kompanija',
      content: 'Sadržaj',
      country: 'Država',
      countryName: 'Naziv države',
      defaultPrice: 'Zadana cijena',
      description: 'Opis',
      fax: 'Faks',
      interestsArea: 'Djelatnost',
      isVisibleOnWeb: 'Vidljivo na webu',
      mpc: 'Maloprodajna cijena',
      name: 'Naziv',
      nc: 'Nabavna cijena',
      nettoWeight: 'Neto težina',
      officeNumber: 'Broj ureda',
      phone: 'Telefon',
      password: 'Lozinka',
      confirmPassword: 'Ponovi lozinku',
      shortDescription: 'Kratak opis',
      symbol: 'Simbol',
      taxGroup: 'Porezna grupa',
      title: 'Naziv',
      town: 'Grad',
      townName: 'Naziv grada',
      unit: 'Jedinica',
      unitOfMeasure: 'Jedinica mjere',
      videoUrl: 'Video link',
      vpc: 'Veleprodajna cijena',
      firstName: 'Ime',
      lastName: 'Prezime',
    },
    errors: {
      default: 'Dogodila se pogreska prilikom validacije.',
      email: 'Polje {field} nije validan email.',
      integer: 'Polje {field} mora biti broj.',
      minLength: 'Minimalno {count} karaktera.',
      required: 'Polje {field} je obavezno.',
      sameAs: 'Polje {field} i polje {field2} se ne podudaraju.',
      url: 'Polje {field} nije validan url.',
    },
  },
  tables: {
    email: 'E-mail',
    firstLastName: 'Ime i prezime',
    id: 'ID',
    name: 'Naziv',
    phone: 'Telefon',
    town: 'Grad',
    username: 'Korisničko ime',
  },
};
